import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgIf } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { DialogRequest } from './dialog.service';
import { sanitizeText, validateValue } from './validation';

@Component({
  selector: 'app-material-confirm-dialog',
  standalone: true,
  imports: [FormsModule, NgIf, MatDialogModule, MatButtonModule, MatFormFieldModule, MatInputModule],
  template: `
    <h2 mat-dialog-title>{{ data.title }}</h2>
    <mat-dialog-content>
      <p class="dialog-message">{{ data.message }}</p>
      <mat-form-field appearance="outline" class="notes-field" *ngIf="data.requireNotes">
        <mat-label>{{ data.notesLabel || 'Notes / reason' }}</mat-label>
        <textarea matInput [(ngModel)]="notes" rows="4" maxlength="300"></textarea>
        <mat-error *ngIf="error">{{ error }}</mat-error>
      </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button type="button" (click)="close(false)">{{ data.cancelText || 'Cancel' }}</button>
      <button mat-flat-button [color]="data.tone === 'danger' ? 'warn' : 'primary'" type="button" (click)="close(true)">
        {{ data.confirmText || 'Confirm' }}
      </button>
    </mat-dialog-actions>
  `,
  styles: [`
    .dialog-message { color: #475569; margin: 0 0 16px; line-height: 1.5; }
    .notes-field { width: 100%; }
  `]
})
export class MaterialConfirmDialogComponent {
  notes = '';
  error = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogRequest,
    private dialogRef: MatDialogRef<MaterialConfirmDialogComponent>
  ) {}

  /**
   * Closes the dialog, enforcing notes when the action requires an audit reason.
   * @param confirmed Whether the user confirmed the action.
   * @returns void.
   */
  close(confirmed: boolean) {
    this.notes = sanitizeText(this.notes);
    const validationMessage = validateValue(this.data.notesLabel || 'Notes / reason', this.notes, {
      required: confirmed && this.data.requireNotes,
      kind: 'textarea',
      maxLength: 300
    });
    if (confirmed && validationMessage) {
      this.error = validationMessage;
      return;
    }
    this.dialogRef.close({ confirmed, notes: this.notes });
  }
}
